var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('myswiper',{attrs:{"swipers":_vm.swipers}})],1),_vm._v(" "),_c('grid'),_vm._v(" "),_c('el-container',[_c('paymentlist'),_vm._v(" "),_c('el-main',[_c('notice')],1),_vm._v(" "),_c('el-footer',[_vm._v("\n      Developed by 龍科技\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38285b65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/lifepay.vue
// module id = null
// module chunks = 